/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_GInputs */

const en_mk_tut_ws_g = /** @type {(inputs: Mk_Tut_Ws_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workspace is your company’s “office” inside the product. All your data is enclosed in it and never mixes with another company’s.`)
};

const id_mk_tut_ws_g = /** @type {(inputs: Mk_Tut_Ws_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace adalah "kantor" perusahaan Anda di dalam produk ini. Semua data terkurung di dalamnya dan tidak pernah bercampur dengan perusahaan lain.`)
};

/**
* | output |
* | --- |
* | "A workspace is your company’s “office” inside the product. All your data is enclosed in it and never mixes with another company’s." |
*
* @param {Mk_Tut_Ws_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_g = /** @type {((inputs?: Mk_Tut_Ws_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_g(inputs)
	return en_mk_tut_ws_g(inputs)
});